module.exports = __webpack_public_path__ + "static/money-4d94715908401d4f5a7e163aa905c170.png";